<template>
  <sui-segment-group
    class="card-payment-settings"
    raised
  >
    <sui-segment
      inverted
      class="section-title"
    >
      Comisión de pago con tarjeta
    </sui-segment>

    <sui-segment :loading="loading">
      <sui-message info>
        Estos cargos se aplican a las nuevas órdenes pagadas con tarjeta de crédito o débito. El sistema agrega IVA a la comisión al calcular la orden.
      </sui-message>

      <sui-form>
        <sui-form-field>
          <label>Comisión porcentual</label>
          <div class="ui right labeled input">
            <input
              v-model.number="commission.commission_percent"
              type="number"
              min="0"
              max="100"
              step="0.01"
              placeholder="3.00"
            >
            <div class="ui basic label">
              %
            </div>
          </div>
        </sui-form-field>

        <sui-form-field>
          <label>Comisión fija</label>
          <div class="ui left labeled input">
            <div class="ui basic label">
              $
            </div>
            <input
              v-model.number="commission.commission_amount"
              type="number"
              min="0"
              max="99.99"
              step="0.01"
              placeholder="0.00"
            >
          </div>
        </sui-form-field>
      </sui-form>
    </sui-segment>

    <sui-segment>
      <sui-message
        v-if="errorMessage"
        error
      >
        {{ errorMessage }}
      </sui-message>
      <sui-button
        positive
        :loading="saving"
        :disabled="loading"
        @click="save"
      >
        Guardar
      </sui-button>
    </sui-segment>
  </sui-segment-group>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import { useToast } from "vue-toastification";
import Api from "../../api/Api";

const toast = useToast();
const loading = ref(true);
const saving = ref(false);
const errorMessage = ref("");
const commission = reactive({
    commission_percent: 0,
    commission_amount: 0,
});

const validate = () => {
    const percent = Number(commission.commission_percent);
    const amount = Number(commission.commission_amount);

    if (!Number.isFinite(percent) || percent < 0 || percent > 100) {
        return "La comisión porcentual debe estar entre 0 y 100%.";
    }
    if (!Number.isFinite(amount) || amount < 0 || amount > 99.99) {
        return "La comisión fija debe estar entre $0 y $99.99.";
    }
    return "";
};

const load = async () => {
    loading.value = true;
    try {
        const response = await Api.getCardPaymentCommission();
        if (response.error) {
            return toast.error(response.message_client);
        }
        commission.commission_percent = Number(response.data.commission_percent) || 0;
        commission.commission_amount = Number(response.data.commission_amount) || 0;
    } catch (error) {
        toast.error("No se pudo cargar la comisión de tarjeta.");
    } finally {
        loading.value = false;
    }
};

const save = async () => {
    errorMessage.value = validate();
    if (errorMessage.value) return;

    saving.value = true;
    try {
        const response = await Api.setCardPaymentCommission({
            commission_percent: Number(commission.commission_percent),
            commission_amount: Number(commission.commission_amount),
        });
        if (response.error) {
            return toast.error(response.message_client);
        }
        commission.commission_percent = Number(response.data.commission_percent) || 0;
        commission.commission_amount = Number(response.data.commission_amount) || 0;
        toast.success("Comisión de tarjeta guardada.");
    } catch (error) {
        toast.error("No se pudo guardar la comisión de tarjeta.");
    } finally {
        saving.value = false;
    }
};

onMounted(load);
</script>

<style scoped>
.card-payment-settings {
    max-width: 700px;
    margin: auto;
}

.section-title {
    text-align: center;
    font-size: 18px;
}
</style>
